export const h1 = {
  fontFamily: 'Tobias',
  fontWeight: 'normal',
  fontSize: '56px',
  lineHeight: '64px',
  '@media (max-width:1024px)': {
    fontSize: '40px',
    lineHeight: '48px',
  },
};
export const h2 = {
  fontFamily: 'Tobias',
  fontWeight: 'normal',
  fontSize: '40px',
  lineHeight: '48px',
  '@media (max-width:1024px)': {
    fontSize: '32px',
    lineHeight: '40px',
  },
};
export const h3 = {
  fontFamily: 'Tobias',
  fontWeight: 'normal',
  fontSize: '32px',
  lineHeight: '40px',
  '@media (min-width:901px and max-width:1024px)': {
    fontSize: '24px',
    lineHeight: '32px',
  },
  '@media (max-width:900px)': {
    fontSize: '18px',
    lineHeight: '24px',
  },
};
export const h4 = {
  fontFamily: 'Cadiz',
  fontWeight: 'normal',
  fontSize: '24px',
  lineHeight: '32px',
  '@media (max-width:1024px)': {
    fontSize: '20px',
    lineHeight: '28px',
  },
};
export const body1 = {
  fontFamily: 'Cadiz',
  fontWeight: 'normal',
  fontSize: '16px',
  lineHeight: '24px',
};
export const body2 = {
  fontFamily: 'Cadiz',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '20px',
};
export const body3 = {
  fontFamily: 'Cadiz',
  fontWeight: 'normal',
  fontSize: '12px',
  lineHeight: '16px',
};
export const mono1 = {
  fontFamily: 'Maison Neue',
  fontWeight: 'normal',
  fontSize: '16px',
  lineHeight: '24px',
};
export const mono2 = {
  fontFamily: 'Maison Neue',
  fontWeight: 'normal',
  fontSize: '14px',
  lineHeight: '20px',
};
export const label = {
  fontFamily: 'Cadiz',
  fontWeight: 'normal',
  fontSize: '12px',
  lineHeight: '16px',
};
export const prodLabel1 = {
  fontFamily: 'Maison Neue',
  fontWeight: 'normal',
  fontSize: '12px',
  lineHeight: '16px',
};
export const prodLabel2 = {
  fontFamily: 'Maison Neue',
  fontWeight: '400',
  fontSize: '8px',
  lineHeight: '12px',
};
export const btn = {
  fontFamily: 'Cadiz',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
};
